import React from 'react'
import styled from 'styled-components'
import media from 'styled-media-query'
import BreadRightIcon from './../../../../src/images/BreadRightIcon.svg'
import computeBreadCrumbs from '../../../domain/useCases/computeBreadCrumbs'
import { isNonEmptyObject, isNonEmptyString } from '../../../utils/checks'

const Style = styled.div`
  width: 100%;
  padding: 0 4px;
  display: flex;
  align-items: center;
  ${media.lessThan('medium')`
    .arrow-image{
      margin-right:9.5px;
      margin-left:9.5px;
    }
  `}
  white-space: nowrap;
  overflow: auto;
  font-size: 14px;
  font-weight: 400;
  color: rgb(22, 41, 65);
  text-transform: capitalize;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .arrow-image {
    margin-right: 9.5px;
    margin-left: 9.5px;
  }
  .allCentertitle:hover {
    border-radius: 6px;
    height: 22px;
    padding: 4px;
    color: #232452;
    background: #ebeff4;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
  }
  .allCentertitle::before {
    display: block;
    content: attr(data-text);
    height: 0;
    font-style: normal;
    overflow: hidden;
    visibility: hidden;
    font-size: 12px;
  }
  .allCentertitle {
    border-radius: 6px;
    height: 22px;
    padding: 4px;
    color: #394e66;
    font-size: 12px;
  }
  .breadcrumb:hover {
    color: #232452;
    font-style: normal;
    background: #ebeff4;
    font-weight: 500;
  }
  .breadcrumb {
    border-radius: 6px;
    padding: 4px;
    color: #394e66;
    font-size: 12px;
  }
  .breadcrumb::before {
    display: block;
    content: attr(data-text);
    height: 0;
    font-style: normal;
    overflow: hidden;
    visibility: hidden;
  }
  .location-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Parentcenter {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
  }
  a {
    color: rgb(22, 41, 65);
    text-decoration: none;
  }

  .slash {
    padding-left: 8px;
    padding-right: 8px;
    color: #dedede;
  }
  .selected {
    padding: 4px;
    color: #232452;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    margin-left: 4px;
    cursor: pointer;
  }
  .selected:hover {
    cursor: revert;
    color: #162941;
    margin-left: 4px;
  }
`

const BreadCrumb = ({
  pageType = '',
  shouldDefaultRegionalize = false,
  center = null,
  brand = null,
  location = null,
  term = null,
  locationAllowList = null
}) => {
  const allCentersText = `All ${
    shouldDefaultRegionalize ? 'Centres' : 'Centers'
  }`

  const { breadCrumbs, selectedTitle } = computeBreadCrumbs({
    center,
    location,
    pageType,
    brand,
    term,
    locationAllowList
  })

  return (
    <div className="relative h-auto w-full">
      <Style>
        <div className="Parentcenter">
          <a
            href="/"
            className="allCentertitle"
            data-text={isNonEmptyObject(brand) ? 'Home' : allCentersText}
          >
            {isNonEmptyObject(brand) ? 'Home' : allCentersText}
          </a>
          <img
            className="arrow-image"
            src={BreadRightIcon}
          />
          {breadCrumbs.map((item) => (
            <div
              key={item.slug}
              className="location-title"
            >
              {isNonEmptyString(item.slug) ? (
                <a
                  className="breadcrumb"
                  key={item.title}
                  data-text={`${item.title}`}
                  href={`/${item.slug}/`}
                >
                  {item.title}
                </a>
              ) : (
                <span
                  className="breadcrumb"
                  key={item.title}
                  data-text={`${item.title}`}
                >
                  {item.title}
                </span>
              )}

              <img
                className="arrow-image"
                src={BreadRightIcon}
              />
            </div>
          ))}
          <span className="selected">{selectedTitle}</span>
        </div>
      </Style>
      {selectedTitle && (
        <div
          id="blur"
          className="bg-gradient-to-left to-white-40 absolute right-0 top-0 h-full w-[64px] from-white"
        />
      )}
    </div>
  )
}

export default BreadCrumb
